export const ContractType = Object.freeze({
  PAY_AS_YOU_GO: 'Avulsa',
  PREPAID: 'Pacote',
  CONTRACT: 'Contrato',
});


export function hasExpiringHours({ contrato, pacote_horas, }) {
  return (contrato === ContractType.PREPAID) && (pacote_horas <= 60);
}
